import { defineNuxtPlugin } from '#app'
import { scrollTop } from '@/nuxt-module/src/runtime/util'

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.hook('page:start', () => {
    if (document?.getElementsByClassName('main__container').length)
      getTargetStyle().visibility = 'hidden'

    const { query } = useRoute()
    if (query && query['no-scroll']) return

    scrollTop()
  })
  nuxtApp.hook('page:finish', () => {
    if (
      document?.getElementsByClassName('main__container').length &&
      getTargetStyle().visibility === 'hidden'
    )
      getTargetStyle().visibility = null
  })
})

function getTargetStyle() {
  return document.getElementsByClassName('main__container')[0].style
}
